import "./ModernWebsiteDesign.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import KeyFeatures from "./sections/KeyFeatures";
import ImageGallery from "./sections/ImageGallery";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ModernWebsiteDesignPage() {
  return <div>
      <Header />
      <Hero />
      <KeyFeatures />
      <ImageGallery />
      <CallToAction />
      <Footer />
    </div>;
}